import React, { useEffect, useState } from "react";    
import styled, { keyframes } from "styled-components";
import { TagIF } from "../types";
import axios from "axios";
import { TagIconContainer, TagIcon } from "../icons";

/* Tags.tsx는 태그 목록을 보여주고 태그 필터링을 하는 컴포넌트 */
interface TagsProps {
  tags: TagIF[]; // 태그 목록
  selectedTags: TagIF[];
  onSelectedTags: React.Dispatch<React.SetStateAction<TagIF[]>>;
  // Hooks event 발생 시 state update에 활용되는 함수 유형 => React.Dispatch
  // ?: Optional을 의미함
}

export const Tag = styled.div<{ $selected?: boolean; $searched?: boolean; $isNone?: boolean }>`
  background-color: ${({ $selected, $searched, $isNone, theme }) => (
    $selected ? theme.TAGS.SELECTED.BACKGROUND : 
    $searched ? theme.TAGS.SEARCHED.BACKGROUND : 
    $isNone ? theme.NONE_TAG.BACKGROUND : 
    theme.TAGS.NORMAL.BACKGROUND
    )};
  color: ${({ $selected, $searched, $isNone, theme}) => (
    $selected ? theme.TAGS.SELECTED.FONT_COLOR : 
    $searched ? theme.TAGS.SEARCHED.FONT_COLOR : 
    $isNone ? theme.NONE_TAG.FONT_COLOR : 
    theme.TAGS.NORMAL.FONT_COLOR
    )};

  font-size: 0.8rem;
  font-weight: 600;
  padding: 0.4rem 0.8rem;
  border-radius: 0.5rem;
  cursor: pointer;
  transition: all 0.2s ease;

  border: 1px solid ${({ $selected, $searched, $isNone, theme }) => (
    $selected ? theme.TAGS.SELECTED.BORDER : 
    $searched ? theme.TAGS.SEARCHED.BORDER : 
    $isNone ? theme.NONE_TAG.BORDER : 
    theme.TAGS.NORMAL.BORDER
    )};

  &:hover {
    transform: translateY(-2px);
    background-color: ${({ $selected, $searched, $isNone, theme }) => (
      $selected ? theme.TAGS.HOVER.BACKGROUND.SELECTED : 
      $searched ? theme.TAGS.HOVER.BACKGROUND.SEARCHED : 
      $isNone ? theme.NONE_TAG.BACKGROUND : 
      theme.TAGS.HOVER.BACKGROUND.NORMAL
    )};
    box-shadow: 0 4px 6px -1px ${props => props.theme.TAGS.HOVER.SHADOW};
  }
`;

function Tags({ tags, selectedTags, onSelectedTags } : TagsProps){

    const isThere = (tags:TagIF[], tgt:string):boolean => {
      for (let idx=0; idx<tags.length; idx++){
        if (tags[idx].name == tgt)
          return true;
      }
      return false;
    }

    const selectedTag = (tgt:TagIF) => {
      // 선택한 tag 목록에 현 tag가 포함되어 있다면 
      onSelectedTags(tags => 
        isThere(tags, tgt.name)
        ? tags.filter(t => t.name !== tgt.name) // true: 목록에서 해당 tag 삭제 <toggle event 구현하기 위해>
        : [...tags, tgt]); // false: 목록에 해당 tag 추가
    }

    return (
    <>
      {tags.map(tag => (
        <Tag key={tag.id}
            onClick={() => selectedTag(tag)}
            $selected={selectedTags.includes(tag)}>
          <TagIconContainer>
            <TagIcon />
            {tag.name}
          </TagIconContainer>
        </Tag>
      ))}
    </>);
}

export default Tags;